import {
  IGuestBooking,
  useGuestBookingsById,
} from "@/services/useGuestBooking";
import { Box, Flex, Spinner, Stack, Text } from "@chakra-ui/react";
import { IFormProps, withForm } from "@ui/components/forms";
import { useSelf } from "@ui/services/useUser";
import { Coffee, Sandwich, Utensils } from "lucide-react";
import { Key } from "react";
import { MealDictionary } from "../MealOption";
import { DateTime } from "luxon";

export const getMealIcon = (meal: string) => {
  switch (meal.toLowerCase()) {
    case "breakfast":
      return Coffee;
    case "lunch":
      return Sandwich;
    case "dinner":
      return Utensils;
    default:
      return null;
  }
};

const GuestBookingDetailsForm = ({ Wrapper }: IFormProps) => {
  const { data: me } = useSelf<any>();
  const guests = useGuestBookingsById(me?.id);

  return (
    <Wrapper title={"Guest Booked Meals"} footer={() => undefined}>
      {guests.isLoading || guests.isPending ? (
        <Box mt={6} textAlign="center">
          <Spinner size="lg" color="green.500" thickness="4px" />
          <Text mt={2} fontSize="sm" color="gray.500">
            Loading guest meal bookings...
          </Text>
        </Box>
      ) : !guests.data || guests.data?.length === 0 ? (
        <Text>No guest meal records available at the moment.</Text>
      ) : (
        <>
          <Stack spacing={4}>
            {guests.data?.map(
              (guest: IGuestBooking, index: Key | null | undefined) => {
                const IconComponent =
                  MealDictionary[guest.meal as keyof typeof MealDictionary]
                    ?.icon;
                const mealLabel =
                  MealDictionary[guest.meal as keyof typeof MealDictionary]
                    ?.label;
                return (
                  <Box
                    as="label"
                    borderWidth="1px"
                    borderRadius="md"
                    boxShadow="sm"
                    borderColor={"gray.200"}
                    bg="white"
                    px={4}
                    py={3}
                    minW="full"
                    textAlign="left"
                    transition="all 0.2s"
                    _hover={{ borderColor: "green.500", boxShadow: "md" }}
                    display="flex"
                    flexDirection="column"
                    key={index}
                    position="relative"
                  >
                    <Flex
                      align="center"
                      justifyContent={"space-between"}
                      w={"100%"}
                      gap={3}
                    >
                      <IconComponent
                        size={20}
                        strokeWidth={2}
                        stroke="#555f71"
                      />
                      <Text fontWeight="medium" color="#555f71">
                        {mealLabel ?? guest.meal}
                      </Text>
                      <Text fontWeight="medium" color="#555f71">
                        {DateTime.fromJSDate(
                          new Date(guest.startDate),
                        ).toFormat("dd MMM yyyy")}{" "}
                        -{" "}
                        {DateTime.fromJSDate(new Date(guest.endDate)).toFormat(
                          "dd MMM yyyy",
                        )}
                      </Text>
                    </Flex>
                  </Box>
                );
              },
            )}
          </Stack>
        </>
      )}
    </Wrapper>
  );
};

const GuestBookingDetailsFormHOC = withForm<any, any>(GuestBookingDetailsForm);
export default GuestBookingDetailsFormHOC;
